import styled, { css } from 'styled-components';

export const SizeandPackSec = styled.div`
  padding: 12px 0 0px 12px;
`;

export const SizeHeading = styled.div`
  font-size: 13px;
  font-weight: 500;
  padding-bottom: 14px;
  ${(props) =>
    props.isMaternitySku &&
    css`
      padding-right: 10px;
      display: flex;
      justify-content: space-between;
    `}
`;

export const SizeSubHeading = styled.div`
  // font-size: 12px;
  // font-weight: 600;
  // color: hsl(0deg 0% 0% / 85%);
  font-size: 13px;
  font-weight: 500;
  color: #00000060;
  .titleNew {
    font-size: 16px;
    font-weight: ${(props) =>
    props.showNewDiaperVariantUx
      ? '600'
      : props.showNewLactomamaVariantUx
      ? '600'
      : '500'};
    color: rgba(0, 0, 0, 0.87);
  }
  .sizeSelectHeadNew {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 600;
  }
`;

export const SizeChartButton = styled.p`
  color: #ef4e5e;
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;
